import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../components/Home/Home';
import Services from '../pages/Services/Services';
import Information from '../pages/Info/Information';
import Doctors from '../pages/Doctors/Doctors';
import Feedback from '../pages/Feedback/Feedback';
import Testimonials from '../pages/Testimonials/Testimonials';
import Appointment from '../pages/Appointment/Appointment';
import Doctorinfo from '../pages/Doctorinfo/Doctorinfo';
import Serviceinfo from '../pages/Serviceinfo/Serviceinfo';
import Aboutus from '../pages/Aboutus/Aboutus';
import Contactus from '../pages/Contactus/Contactus';


const Routing = () => {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/information" element={<Information />} />
        <Route path="/doctors" element={<Doctors />} />
        <Route path='/feed-back' element={<Feedback/>}/>
        <Route path='/testimonials' element={<Testimonials/>}/>
        <Route path='/appointments' element={<Appointment/>}/>
        <Route path='/doctor-info' element={<Doctorinfo/>}/>
        <Route path='/service-info' element={<Serviceinfo/>}/>
        <Route path='/about-us' element={<Aboutus/>}/>
        <Route path='/contact-us' element={<Contactus/>}/>
      </Routes>
  );
}

export default Routing;
